<div id="footer" class="position-relative h-100">
    <div class="footer-inner border-top bg-light position-absolute w-100">
        <div class="container py-2">
            <div class="row">
                <div class="col-md-6 ">
                    <div class="py-3 text-secondary">
                        <span class="ft-24">AliceBlue</span>
                        <span class="ps-2 ft-10">© 2019 Aliceblue. All rights reserved.</span>
                    </div>
                </div>
                <div class="col-md-6 text-md-end text-start">
                    <div class="py-3">
                        <!-- <a href="https://aliceblueonline.com/support" target="_blank" class="text-decoration-none text-secondary ft-12">Support portal</a> -->
                        <a href="https://aliceblueonline.com/support" target="_blank" class="bg-darkblue text-light ft-14 rounded px-5 py-2 text-decoration-none">FAQs</a>
                        <span class="ps-3">
                            <a href="https://support.aliceblueonline.com/dashboard/support-page" target="_blank" class="bg-darkblue text-light ft-14 rounded px-4 py-2 text-decoration-none">Raise a Ticket</a>
                        </span>
                    </div>
                </div>
            </div>
            <div class="cor-off py-2 hide-mobile">
                <div class="row">
                    <div class="col-md-9 text-secondary">
                        <div class="pb-3">
                            <p class="ft-12">
                                Corporate Office: No. 153/2, 3rd Floor, M.R.B.Arcade, Bagalur Main Road, Dwaraka Nagar, Yelahanka, Bengaluru - 560063, Karnataka. 
                                <br>
                                Registered Office: Old No.56/2 ,New No.58, LIC Nagar, Vinayagar Kovil Street, Erode -8,Tamil Nadu– 638002.
                            </p>
                        </div>
                        <div class="ft-12">
                            <p>
                                Alice Blue Financial Services (P) Ltd : NSE EQ | NSE FO | NSE CDS-90112 SEBI REG : INZ000156038 <br>
                                Alice Blue Financial Services (P) Ltd : BSE EQ | BSE FO | BSE CD-6670 SEBI REG : INZ000156038 <br>
                                Alice Blue Financial Services (P) Ltd : CDSL DP ID 12085300 DP SEBI REG : IN-DP-364-2018 
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
